import { LitElement, html, css } from 'lit'

class AppToast extends LitElement {
  static properties = {
    _messages: { type: Array, state: true }
  }

  static styles = css`
    :host { position: fixed; bottom: 1rem; right: 1rem; z-index: 1000; display: flex; flex-direction: column; gap: 0.5rem; }
    .toast { padding: 0.75rem 1.25rem; border-radius: 6px; color: white; font-size: 0.875rem; animation: slide-in 0.2s ease; }
    .toast.success { background: #16a34a; }
    .toast.error   { background: #dc2626; }
    .toast.info    { background: #2563eb; }
    @keyframes slide-in { from { transform: translateX(100%); opacity: 0; } to { transform: none; opacity: 1; } }
  `

  constructor() {
    super()
    this._messages = []
    window.addEventListener('app:toast', (e) => this._show(e.detail))
  }

  _show({ message, type = 'info', duration = 4000 }) {
    const id = Date.now()
    this._messages = [...this._messages, { id, message, type }]
    setTimeout(() => {
      this._messages = this._messages.filter(m => m.id !== id)
    }, duration)
  }

  render() {
    return html`${this._messages.map(m => html`
      <div class="toast ${m.type}">${m.message}</div>
    `)}`
  }
}

customElements.define('app-toast', AppToast)

export function toast(message, type = 'info', duration = 4000) {
  window.dispatchEvent(new CustomEvent('app:toast', { detail: { message, type, duration } }))
}
